import { render, staticRenderFns } from "./activityStream.vue?vue&type=template&id=5e85e4ea&"
import script from "./activityStream.js?vue&type=script&lang=js&"
export * from "./activityStream.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports